import { render, staticRenderFns } from "./Lobby2.vue?vue&type=template&id=6f1e8c3a"
import script from "./Lobby2.vue?vue&type=script&lang=js"
export * from "./Lobby2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports